import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, Slide, AppBar, Toolbar, IconButton, Typography, Paper, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FormControl, Button, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import UserService from '../../services/UserService';
import FieldNames from '../../defaults/FieldNames.json';
import GridDefinitions from '../../defaults/GridDefinitions.json';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AuditLogService from '../../services/AuditLogService';
import {formatDateForDisplay, getSaveableDate} from "../../utils/DateHelper";
import ErrorService from '../../services/ErrorService';
import BasicTextField from '../details/customPanels/BasicTextField';
import ColorConstants from '../../defaults/ColorConstants';

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red"
    },
    "&&:after": {
      borderBottom: "2px solid red"
    }
  },
  condensedFormControl: {
    margin: "5px 15px 5px 15px",
    minWidth: 120,
    width: '90%'
  },
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '90%'
  },
  snackBarStyle: {
    top: '120px !important'
  },
});

const theme = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: 'green'
      }
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          //initial border
          borderColor: ColorConstants.BlueAlien,
        },
        '&:hover $notchedOutline': {
          //border on hover
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
      },
    }
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProfileDialog({open, onClose}) {
  const userInfo = useSelector((state) => state.globalContext.userInfo);
  const userRoleInfo = useSelector((state) => state.globalContext.userRoleInfo);
  const [firstName, setFirstName] = useState(userInfo[FieldNames.userFields.firstName]);
  const [lastName, setLastName] = useState(userInfo[FieldNames.userFields.lastName]);
  const [email, setEmail] = useState(userInfo[FieldNames.userFields.email]);
  const [nifcUsername] = useState(userInfo[FieldNames.userFields.nifcUsername]);
  const [userIsAdmin] = useState(userInfo[FieldNames.userFields.isAdmin]);
  const [userIsFuels] = useState(userInfo[FieldNames.userFields.isFuels]);
  const [userIsPostFire] = useState(userInfo[FieldNames.userFields.isPostFire]);
  const [userIsTribal] = useState(userInfo[FieldNames.userFields.isTribalUser]);
  const [snackbarOpenProfile, setSnackbarOpenProfile] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isFailure, setIsFailure] = useState(false);
  const classes = useStyles();
  const [currentUserRoles, setCurrentUserRoles] = useState(null);
  const [currentFundingDepartments, setCurrentFundingDepartments] = useState([]);
  const [currentFundingAgencies, setCurrentFundingAgencies] = useState([]);
  const [currentFundingRegions, setCurrentFundingRegions] = useState([]);
  const [currentFundingUnits, setCurrentFundingUnits] = useState([]);
  const [currentFundingSubUnits, setCurrentFundingSubUnits] = useState([]);
  const [currentFundingTribes, setCurrentFundingTribes] = useState([]);
  const [createdBy] = useState(userInfo[FieldNames.userFields.createdBy]); 
  const [createdOn] = useState(userInfo[FieldNames.userFields.createdOnDate] ? formatDateForDisplay(userInfo[FieldNames.userFields.createdOnDate]) : null);
  const [modifiedBy] = useState(userInfo[FieldNames.userFields.lastModifiedBy]);
  const [modifiedOn] = useState(userInfo[FieldNames.userFields.lastModifiedDate] ? formatDateForDisplay(userInfo[FieldNames.userFields.lastModifiedDate]) : null);
  const [userHistoryRows,setUserHistoryRows] = useState([]);
  const [userHistoryCols,setUserHistoryCols] = useState([]);
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const nifcToken = useSelector((state) => state.configuration.nifcToken);

  const userAuditLogGridColDefinitions = [
    GridDefinitions.UserAuditLog.modifiedBy,
    GridDefinitions.UserAuditLog.modifiedOn,
    GridDefinitions.UserAuditLog.modification
  ];

  useEffect(() => {
    //Process here
    let savedRoles = [];
    let savedRegions = [];
    let savedUnits = [];
    let savedAgencies = [];
    let savedDepartments = [];
    let savedSubUnits = [];
    let savedTribes = [];
    userRoleInfo.forEach(savedUserRole => {
      if(savedUserRole){
        if(savedUserRole[FieldNames.userRoles.appRole] && savedRoles && !savedRoles.includes(savedUserRole[FieldNames.userRoles.appRole])){
          savedRoles.push(savedUserRole[FieldNames.userRoles.appRole]);
        }
        if(savedUserRole[FieldNames.userRoles.department] && savedDepartments && !savedDepartments.includes(savedUserRole[FieldNames.userRoles.department])){
          savedDepartments.push(savedUserRole[FieldNames.userRoles.department]);
        }
        if(savedUserRole[FieldNames.userRoles.agency] && savedAgencies && !savedAgencies.includes(savedUserRole[FieldNames.userRoles.agency])){
          savedAgencies.push(savedUserRole[FieldNames.userRoles.agency]);
        }
        if(savedUserRole[FieldNames.userRoles.region] && savedRegions && !savedRegions.includes(savedUserRole[FieldNames.userRoles.region])){
          savedRegions.push(savedUserRole[FieldNames.userRoles.region]);
        }
        if(savedUserRole[FieldNames.userRoles.unit] && savedUnits && !savedUnits.includes(savedUserRole[FieldNames.userRoles.unit])){
          savedUnits.push(savedUserRole[FieldNames.userRoles.unit]);
        }
        if(savedUserRole[FieldNames.userRoles.subUnit] && savedSubUnits && !savedSubUnits.includes(savedUserRole[FieldNames.userRoles.subUnit])){
          savedSubUnits.push(savedUserRole[FieldNames.userRoles.subUnit]);
        }
        if(savedUserRole[FieldNames.userRoles.tribe] && savedTribes && !savedTribes.includes(savedUserRole[FieldNames.userRoles.tribe])){
          savedTribes.push(savedUserRole[FieldNames.userRoles.tribe])
        }
      }
    });
    setCurrentUserRoles(savedRoles.join(", "));
    setCurrentFundingDepartments(savedDepartments.join(", "));
    setCurrentFundingAgencies(savedAgencies.join(", "));
    setCurrentFundingRegions(savedRegions.join(", "));
    setCurrentFundingUnits(savedUnits.join(", "));
    setCurrentFundingSubUnits(savedSubUnits.join(", "));
    setCurrentFundingTribes(savedTribes.join(", "));

    establishGridColumns();
    getAuditLog();
    
  }, [userRoleInfo])

  const getAuditLog = () => {
    if(userRoleInfo)
    {
      AuditLogService.getEntityAuditLog(
        FieldNames.auditLogJoinTypes.users, userInfo[FieldNames.userFields.id].toString()).then(userAuditRows => {
        if(userAuditRows && userAuditRows.length > 0){
          var mappedRows = userAuditRows.map((auditRow) => {
            try{
              return {id: auditRow.OBJECTID, ModifiedBy: auditRow.ModifiedBy, ModifiedDate: formatDateForDisplay(auditRow.ModifiedDate),
                    Modification: JSON.parse(auditRow.AuditEntryJson)[0]}
            } catch(e){
              return {id: auditRow.OBJECTID, ModifiedBy: auditRow.ModifiedBy, ModifiedDate: formatDateForDisplay(auditRow.ModifiedDate),
                Modification: auditRow.AuditEntryJson}
            }
          })
  
          setUserHistoryRows(mappedRows);
        } else {
          setUserHistoryRows([]);
        }
      }).catch(error => {
        ErrorService.addErrorLogEntry(error);
      });
    }
  }

  const handleSaveUser = () => {
    let currDate = getSaveableDate(new Date());
    let updatedUserInfo = {};
    updatedUserInfo[FieldNames.userFields.userID] = userInfo[FieldNames.userFields.userID];
    updatedUserInfo[FieldNames.userFields.objectID] = userInfo[FieldNames.userFields.objectID];
    updatedUserInfo[FieldNames.userFields.firstName] = firstName;
    updatedUserInfo[FieldNames.userFields.lastName] = lastName;
    updatedUserInfo[FieldNames.userFields.email] = email;
    updatedUserInfo[FieldNames.userFields.lastModifiedBy] = nifcUsername;
    updatedUserInfo[FieldNames.userFields.lastModifiedDate] = currDate;
    UserService.updateUser(rootServiceUrl, nifcToken, updatedUserInfo, config).then(response => {
      if(response && response.updateResults && response.updateResults[0].success){
        AuditLogService.addAuditLogEntry(
          userInfo, userInfo[FieldNames.userFields.id], FieldNames.auditLogJoinTypes.users, nifcUsername,
          ["User was modified"]).then(response => {
            getAuditLog();
           }).catch(error => {
            ErrorService.addErrorLogEntry(error);
          });
        setIsFailure(false);
        setSnackbarMessage("User created successfully.");
        setSnackbarOpenProfile(true);
      } else {
        setIsFailure(true);
        setSnackbarMessage("User create failed!");
        setSnackbarOpenProfile(true);
      }
    }).catch(error => {
      ErrorService.addErrorLogEntry(error);
    });
  }

  const handleCancel = () => {
    setFirstName(userInfo[FieldNames.userFields.firstName]);
    setLastName(userInfo[FieldNames.userFields.lastName]);
    setEmail(userInfo[FieldNames.userFields.email]);
  }

  const establishGridColumns = () => {
    let columns = [];
    userAuditLogGridColDefinitions.forEach((colDef) => {
      columns.push({
        field: colDef.value,
        headerName: colDef.header,
        type: colDef.type,
        hideable: colDef.hideable,
        sortable: colDef.sortable,
        editable: colDef.editable,
        flex: colDef.flex,
        align: colDef.align,
        disableExport: colDef.disableExport,
        valueGetter: (value) => {
          return value; // Used for formatting string values I.E. currency formatting
        },
      });
    });


    setUserHistoryCols(columns);
  };

  return (
    <Dialog
      style={{ minWidth: 550, backgroundColor: ColorConstants.LightGrayAlien }}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
      open={open}
      className="dialog-modal"
      PaperProps={{ 
        style: {
          backgroundColor: ColorConstants.LightGrayAlien
        }
      }}>
      <AppBar sx={{ position: 'relative' }} style={{ backgroundColor: ColorConstants.BlueAlien }}>
        <Toolbar style={{ color: ColorConstants.WhiteAlien }}>
          <IconButton
            edge="start"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon style={{ fill: ColorConstants.WhiteAlien }} />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            My Account
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid container style={{ backgroundColor: ColorConstants.LightGrayAlien }}>
        <Grid item size={12} xl={6} container >
        <Paper elevation={6} style={{ padding: 20, margin: 20 }}>
            <h2>Profile</h2>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>First Name</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <BasicTextField
                      field="firstName"
                      label="First Name"
                      value={firstName}
                      setValue={setFirstName}
                      variant={"standard"}
                      placeholder={"Enter first name"}
                      useFullWidth={true}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Last Name</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <BasicTextField
                      field="lastName"
                      label="Last Name"
                      value={lastName}
                      setValue={setLastName}
                      variant={"standard"}
                      placeholder={"Enter last name"}
                      useFullWidth={true}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Email</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <BasicTextField
                      field="email"
                      label="Email"
                      value={email}
                      setValue={setEmail}
                      variant={"standard"}
                      placeholder={"Enter email"}
                      useFullWidth={true}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Nifc Username</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{nifcUsername}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Is Admin</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{userIsAdmin}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Is Fuels</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{userIsFuels}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Is Post Fire</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{userIsPostFire}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.condensedFormControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center', paddingRight: '5px' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Is Tribal</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{userIsTribal}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Roles</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                  <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentUserRoles}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Departments</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingDepartments}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Agencies</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingAgencies}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Regions</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingRegions}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            <FormControl variant="standard" className={classes.formControl}>
              <ThemeProvider theme={theme}>
                <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                  <Grid item size={3}>
                    <span>
                      <label>Units</label>
                    </span>
                  </Grid>
                  <Grid item size={9}>
                    <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingUnits}</p>
                  </Grid>
                </Grid>
              </ThemeProvider>
            </FormControl>
            {(currentFundingAgencies && currentFundingAgencies.includes(FieldNames.agencies.blm)) &&
              <FormControl variant="standard" className={classes.formControl}>
                <ThemeProvider theme={theme}>
                  <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                    <Grid item size={3}>
                      <span>
                        <label>SubUnits</label>
                      </span>
                    </Grid>
                    <Grid item size={9}>
                      <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingSubUnits}</p>
                    </Grid>
                  </Grid>
                </ThemeProvider>
              </FormControl>
            }
            {(currentFundingAgencies && currentFundingAgencies.includes(FieldNames.agencies.bia) && userIsTribal) &&
              <FormControl variant="standard" className={classes.formControl}>
                <ThemeProvider theme={theme}>
                  <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
                    <Grid item size={3}>
                      <span>
                        <label>Tribe</label>
                      </span>
                    </Grid>
                    <Grid item size={9}>
                      <p style={{color: ColorConstants.Default, borderBottom: `1px dotted ${ColorConstants.Default}`}}>{currentFundingTribes}</p>
                    </Grid>
                  </Grid>
                </ThemeProvider>
              </FormControl>
            }
            <Box alignItems="center" justifyContent="center" sx={{paddingTop: "10px !important", paddingBottom: "10px !important"}}>
              <Grid marginLeft={"2%"} container>
                  <Grid item md={5}>
                      <Typography fontWeight={"fontWeightBold"}>Created By:</Typography> {createdBy}
                  </Grid>
                  <Grid item md={5}>
                    <Typography fontWeight={"fontWeightBold"}>Last Modified By:</Typography> {modifiedBy}
                  </Grid>
              </Grid>
              <Grid marginLeft={"2%"} container>
                  <Grid item md={5}>
                   <Typography fontWeight={"fontWeightBold"}>Created On:</Typography> {createdOn}
                  </Grid>
                  <Grid item md={5}>
                    <Typography fontWeight={"fontWeightBold"}>Last Modified On:</Typography> {modifiedOn}
                  </Grid>
              </Grid>
            </Box>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>View History</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{height: "250px", width: "100%", minWidth: "10px"}}>
                  <DataGridPremium
                    rows={userHistoryRows}
                    columns={userHistoryCols}>
                  </DataGridPremium>
                </Box>
              </AccordionDetails>
            </Accordion>
            <DialogActions>
              <Button
                color="primary"
                variant="contained"
                style={{marginTop: "10px", marginRight: '15px', width: 100}}
                onClick={handleSaveUser}>Save
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{marginTop: "10px", marginLeft:"15px", marginRight: '15px', width: 100}}
                onClick={handleCancel}>Cancel
              </Button>
            </DialogActions>
          </Paper>
        </Grid>
       
      </Grid>
      <ThemeProvider theme={theme}>
      <Snackbar open={snackbarOpenProfile} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        className={classes.snackBarStyle}
        onClose={() => {
          setSnackbarOpenProfile(false);
          setSnackbarMessage("");
        }}>
          <Alert onClose={() => {
          setSnackbarOpenProfile(false);
          setSnackbarMessage("");
          }} severity={isFailure ? "error" : "success"} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
      </Snackbar>
      </ThemeProvider>
    </Dialog>
  )
  
}

ProfileDialog.propTypes = {
  open: PropTypes.bool, 
  onClose: PropTypes.func,
}